// Derives an Open Library cover URL from a Book resource's ISBN (issue #320).
// Book.isbn is unvalidated free text on the backend ("N/A", hyphenated,
// "(pbk)"-suffixed), so the value is normalised and validated here; anything
// that is not a plausible ISBN yields null, so the card falls back to the
// type icon without issuing any request.

// ISBN-10: 9 digits + digit-or-X check digit. ISBN-13: 13 digits.
const ISBN_PATTERN = /^(\d{9}[\dXx]|\d{13})$/

export const normalizeIsbn = (raw) => {
    if (typeof raw !== 'string') return null
    const cleaned = raw.trim().replace(/[-\s]/g, '')
    return ISBN_PATTERN.test(cleaned) ? cleaned : null
}

// ?default=false makes Open Library answer a real HTTP 404 for unknown ISBNs
// instead of a grey placeholder image, so the <img> onError fallback fires.
export const openLibraryCover = (raw) => {
    const isbn = normalizeIsbn(raw)
    return isbn
        ? `https://covers.openlibrary.org/b/isbn/${isbn}-M.jpg?default=false`
        : null
}
